import { Enums } from "../common/enums";
import { OpImportPluginParam } from "../util/op-import-plugin-param";

export class OpImportProgressStep {

    //Properties

    public importStatus: Enums.ImportStatus
    public itemsCount: number
    public proceedItemsCount: number
    public proceedSuccessItemsCount: number
    public proceedErrorItemsCount: number
    public proceedWarningItemsCount: number
    public proceedSkippedItemsCount: number

    //Properties end

    constructor(opObj: any = null) {
        if (opObj) {
            this.importStatus = opObj.ImportStatus
            this.itemsCount = opObj.ItemsCount
            this.proceedItemsCount = opObj.ProceedItemsCount
            this.proceedSuccessItemsCount = opObj.ProceedSuccessItemsCount
            this.proceedErrorItemsCount = opObj.ProceedErrorItemsCount
            this.proceedWarningItemsCount = opObj.ProceedWarningItemsCount
            this.proceedSkippedItemsCount = opObj.ProceedSkippedItemsCount
        } else {
            this.importStatus = Enums.ImportStatus.Unknown
            this.itemsCount = 0
            this.proceedItemsCount = 0
            this.proceedSuccessItemsCount = 0
            this.proceedErrorItemsCount = 0
            this.proceedWarningItemsCount = 0
            this.proceedSkippedItemsCount = 0
        }
    }
}